/**
 * Browserbase Session Configuration Types
 *
 * User-controlled settings for browser session management.
 * Single source of truth for session configuration across frontend and backend.
 */

/**
 * Session management configuration for Browserbase nodes
 */
export interface SessionConfig {
  /** Whether to save session to database for replay (default: true) */
  saveSession?: boolean;
  /** How long to keep session viewable in hours (default: 24) */
  sessionTTL?: number;
  /** Whether to auto-cleanup expired sessions (default: true) */
  autoCleanup?: boolean;
  /** Days before deleting expired sessions (default: 7) */
  cleanupAfterDays?: number;
}

/**
 * Default session configuration values
 */
export const DEFAULT_SESSION_CONFIG: Required<SessionConfig> = {
  saveSession: true,
  sessionTTL: 24, // 24 hours
  autoCleanup: true,
  cleanupAfterDays: 7 // 7 days grace period
};

/**
 * Session configuration constraints
 */
export const SESSION_CONFIG_CONSTRAINTS = {
  sessionTTL: {
    min: 1,
    max: 720, // 30 days
    default: 24
  },
  cleanupAfterDays: {
    min: 1,
    max: 90,
    default: 7
  }
} as const;
